// extracted by mini-css-extract-plugin
module.exports = {"sale-title":"_1ymB4","saleTitle":"_1ymB4","sale-button":"_12Hc9","saleButton":"_12Hc9","sale-second-title":"_1iA3v","saleSecondTitle":"_1iA3v"};